var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlStar = function SvgVaknlStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.53 9.14-3.73 2.72 1.35 4.28a.857.857 0 0 1-.3.93.86.86 0 0 1-.51.17.854.854 0 0 1-.46-.14L10 14.51 6.12 17.1a.858.858 0 0 1-.97-.03.835.835 0 0 1-.29-.93l1.34-4.28-3.74-2.72a.901.901 0 0 1-.3-.92.832.832 0 0 1 .77-.59l4.74-.09 1.54-4.26a.842.842 0 0 1 1.58 0l1.54 4.26 4.73.09a.927.927 0 0 1 .78.59.84.84 0 0 1-.31.92z"
  })));
};
export default SvgVaknlStar;